import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography, Button } from '@mui/material';
import { SlideTransition } from '../../../../../../components/Transition/Transition';
import CustomInputSelect from '../../../../../Analysis/partials/CustomInputSelect/CustomInputSelect';

const CurrencyInputDialog = props => {
  const { intl, currency, open, onClose } = props;

  const [internalCurrency, setInternalCurrency] = useState(currency);

  useEffect(() => {
    setInternalCurrency(currency);
  }, [currency]);

  const onChange = event => {
    setInternalCurrency(event.target.value);
  };

  const cancel = () => {
    onClose();
  };

  const submit = () => {
    onClose(internalCurrency);
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      slots={{
        transition: SlideTransition
      }}
    >
      <DialogTitle>{intl.formatMessage({ id: 'pf-currency-dialog-title' })}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ flexDirection: 'column' }}>
          <Grid>
            <Typography>{intl.formatMessage({ id: 'pf-currency-dialog-content' })}</Typography>
          </Grid>
          <Grid>
            <Grid
              container
              spacing={1}
              sx={{
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Grid>
                <Typography>{intl.formatMessage({ id: 'pf-currency-dialog-currency-label' })}</Typography>
              </Grid>
              <Grid style={{ minWidth: 64 }}>
                <CustomInputSelect
                  value={internalCurrency}
                  onChange={onChange}
                  selectOptions={[
                    {
                      value: 1 / 7.8,
                      label: '0.128 (1/7.8)'
                    },
                    1,
                    7.8
                  ]}
                  allowCustomValue={true}
                  min={0}
                  decimalPlaces={3}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={cancel}>
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button color="primary" onClick={submit}>
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(CurrencyInputDialog);
